import Tippy from "@tippyjs/react";
import React, { useState, useEffect } from "react";
import cn from "classnames";
import logout from "./logout";
import getUserRole from "./getRole";
import getLinks from "./getLinks";

const LeftMenuTablet = ({ baseUrl, currentUser, classbookUrl }) => {
  const { first_name, last_name, grade_tag, rtk_client, role } = currentUser;
  const { MAIN_LINKS, SUB_LINKS, BOTTOM_LINKS } = getLinks(
    baseUrl,
    classbookUrl
  );
  const [isMenuOpen, setOpenMenu] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      return;
    }
    document.body.style.overflow = "unset";
  }, [isMenuOpen]);

  const handleClick = () => {
    setOpenMenu(!isMenuOpen);
  };

  const renderMainLinks = () => (
    <div className="menu-tablet__main-links">
      {MAIN_LINKS.map(({ text, url }) => (
        <Tippy
          key={url}
          className="menu-tablet__tooltip"
          theme="light"
          placement="right"
          content={text}
        >
          <a href={url} />
        </Tippy>
      ))}
    </div>
  );

  const renderLinks = (array, className) => (
    <div className={className}>
      {array.map(({ url, text }) => (
        <a
          key={url}
          href={url}
          target={url.startsWith(baseUrl) ? "_self" : "_blank"}
        >
          {text}
        </a>
      ))}
    </div>
  );

  const renderUserInfo = () => (
    <div className="menu-tablet__top">
      <div className="menu-tablet__user-container">
        <div className="menu-tablet__user-info">
          <span className="menu-tablet__user-name">
            {first_name} {last_name}
          </span>
          <span className="menu-tablet__user-detals">
            {getUserRole(role)} / {grade_tag}
          </span>
        </div>
        <button className={cn("menu-tablet__logout")} onClick={logout} />
      </div>
      {rtk_client && (
        <a href={`${baseUrl}payment`} className="menu-tablet__payment">
          Пополнить счёт
        </a>
      )}
    </div>
  );

  const renderMenu = () => (
    <div
      className={cn("menu-tablet__modal", {
        active: isMenuOpen,
      })}
    >
      <div className="menu-tablet__overlay">
        <div className="menu-tablet__wrapper">
          <div className="menu-tablet__container">
            {renderUserInfo()}
            {renderLinks(SUB_LINKS, "menu-tablet__submenu")}
            {renderLinks(BOTTOM_LINKS, "menu-tablet__bottom")}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className={cn("menu-tablet", { "menu-is-open": isMenuOpen })}>
        <div className="menu-tablet__wrap">
          <div className="menu-tablet__logo" />
          {renderMainLinks()}
          <button
            className={cn("menu-tablet__open-btn", {
              "active-btn": isMenuOpen,
            })}
            onClick={handleClick}
          />
        </div>
      </div>
      {renderMenu()}
    </React.Fragment>
  );
};

export default LeftMenuTablet;



// WEBPACK FOOTER //
// ./app/frontend/components/LeftMenuTablet.js